import React from 'react';
import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import { Section } from '../../styled-components';
import ReviewsCarousel from '../carousels/reviews';
import { ClasiQuote } from '../../icons';

const SectionCustom = styled(Section)`
  position: relative;
  overflow: hidden;
  padding: 0;                 /* el título va sobre la imagen */
  margin-top: -7rem;

  /* Fondo con imagen + oscurecedor */
  background-image:
    linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0)),
    url(${p => p.bgImg});
  background-size: 100% 100%, cover;
  background-position: center, 0% 35%;
  background-repeat: no-repeat, no-repeat;

  min-height: clamp(360px, 58vw, 640px);
`;

/* Título arriba-izquierda */
const Title = styled.h2`
  position: absolute;
  top: 8%;
  left: 8%;
  margin: 0;
  color: #fff;
  font-weight: 600;
  line-height: 1.1;
  /* tamaño fluido similar a la imagen */
  font-size: clamp(1.6rem, 3.6vw, 3.2rem);
  z-index: 2;
`;

/* Contenedor de las reviews a la derecha sobre la imagen */
const ReviewsWrapper = styled.div`
  position: absolute;
  right: clamp(12px, 4vw, 48px);
  top: 50%;
  transform: translateY(-35%); /* lo acerca al tercio inferior */
  max-width: min(520px, 42vw);
  z-index: 2;
  text-align: left;

  /* mejora legibilidad del texto sobre imagen */
  background: rgba(255,255,255,0.0); /* sin caja visible como en el mock */
`;

/* Comillas moradas grandes */
const Quote = styled.div`
  display: inline-block;
  color: ${p => p.theme.primaryColor || '#6C2BD9'};
  font-size: clamp(2.2rem, 5vw, 4rem);
  line-height: 1;
  margin-bottom: .5rem;

  svg { width: 1em; height: 1em; }
`;

/* Estilo base del texto del carrusel (puedes ajustarlo dentro del componente si ya lo controlas ahí) */
const ReviewText = styled.div`
  color: #111;                 /* en el mock el texto se ve oscuro */
  font-weight: 700;
  font-size: clamp(.95rem, 1.25vw, 1.15rem);
  text-shadow: 0 0 1px rgba(255,255,255,.15);
`;

/* Burbuja de WhatsApp (opcional) */
const WppBubble = styled.a`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 3;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(255,255,255,.85);
  display: grid;
  place-items: center;
  text-decoration: none;
  box-shadow: 0 2px 10px rgba(0,0,0,.25);

  img, svg { width: 24px; height: 24px; }
`;

/* Responsive: en móviles baja el bloque de reviews para que no tape el título ni el foco */
const Responsive = styled(Container)`
  @media (max-width: 768px) {
    ${ReviewsWrapper} {
      right: 16px;
      left: 16px;
      top: auto;
      bottom: 16px;
      transform: none;
      max-width: none;
    }
  }
`;

export default function ReviewsHero({ bgImg, items, title = 'Nuestros clientes hablan de nosotros' }) {
  return (
    <SectionCustom bgImg={bgImg}>
      <Title>{title}</Title>

      {/* Opcional: reemplaza href con tu link o elimina el componente */}
      {/* <WppBubble href="https://wa.me/569xxxxxxxx" target="_blank" rel="noopener noreferrer">
        <img src="/icons/whatsapp.svg" alt="WhatsApp" />
      </WppBubble> */}

      <Responsive fluid>
        <ReviewsWrapper>
          <Quote><ClasiQuote /></Quote>
          {/* Si tu ReviewsCarousel ya pinta el texto, basta con usarlo. 
              Si no, puedes envolver su contenido con ReviewText desde dentro */}
          <ReviewText>
            <ReviewsCarousel items={items} />
          </ReviewText>
        </ReviewsWrapper>
      </Responsive>
    </SectionCustom>
  );
}